import { createSlice } from '@reduxjs/toolkit'
import {
  defaultPage,
  defaultSize,
  defaultSortDir,
  defaultTotalElements,
  defaultSortBy,
  defaultTotalPages,
} from '../../../constants/index'

const initialState = {
  configPagination: [],
  getSingleConfig: null,
  // Editor-friendly font shape: each entry has 'file-name' / 'file-path'
  // plus the original FontDefinition fields. See toLegacyFontShape.
  getFontList: [],
  pageable: {
    pageNo: defaultPage,
    pageSize: defaultSize,
    sortBy: defaultSortBy,
    sortDir: defaultSortDir,
    totalPages: defaultTotalPages,
    totalElements: defaultTotalElements,
  },
  outputUrlsPagination: [],
  outputUrlsPageable: {
    pageNo: defaultPage,
    pageSize: defaultSize,
    sortBy: defaultSortBy,
    sortDir: defaultSortDir,
    totalPages: defaultTotalPages,
    totalElements: defaultTotalElements,
  },
  // [{ value, label }] — populated by GET /hpi/config/vAlignment.
  vAlignmentOptions: [],
  // Populated by POST /hpi/stats (or /hpi/stats/iterations) — drives the
  // campaign dashboard's KPI cards, iteration dropdown, and time chart.
  hpiCampaignStats: null,
}

const hpiSlice = createSlice({
  name: 'hpiconfig',
  initialState: initialState,
  reducers: {
    configPaginationFetched: (state, action) => {
      state.configPagination = action.payload.content
      state.pageable = {
        ...state.pageable,
        pageNo: action.payload.pageNo,
        pageSize: action.payload.pageSize,
        totalElements: action.payload.totalElements,
        totalPages: action.payload.totalPages,
      }
    },
    configFetchedById: (state, action) => {
      state.getSingleConfig = action.payload
    },
    fontListFetched: (state, action) => {
      state.getFontList = Array.isArray(action.payload) ? action.payload : []
    },
    outputUrlsPaginationFetched: (state, action) => {
      state.outputUrlsPagination = action.payload.content
      state.outputUrlsPageable = {
        ...state.outputUrlsPageable,
        pageNo: action.payload.number, // Note: Spring Data returns 'number' for page index
        pageSize: action.payload.size,
        totalElements: action.payload.totalElements,
        totalPages: action.payload.totalPages,
      }
    },
    vAlignmentOptionsFetched: (state, action) => {
      state.vAlignmentOptions = Array.isArray(action.payload) ? action.payload : []
    },
    hpiCampaignStatsFetched: (state, action) => {
      state.hpiCampaignStats = action.payload
    },
  },
})

export default hpiSlice
